import { LoadingIndicator } from '@repo/components/loading-indicator';

export function PageLoading() {
  return <LoadingIndicator className="p-8 text-primary-700" size={48} strokeWidth={4} />;
}
